import { usStatesObject } from '../utilities'

export default (states) => ({
	allStates: usStatesObject,
	currentStates: states,
	activeState: null,
	showRecipe: false,
	goToPage(url) {
		window.location.href = url
	},
	get stateHref() {
		return this.currentStates[this.activeState] + '#state-recipe'
	},
	init() {
		const alpine = this
		const svgStates = this.$refs.stateMap.querySelectorAll('g > g')

		svgStates.forEach((state) => {
			// Check which color class the state has and add corresponding inactive variant
			if (state.id in this.currentStates) {
				state.classList.add('hover:text-orange-400', 'cursor-pointer')

				const url = this.currentStates[state.id]
				const link = document.createElementNS(
					'http://www.w3.org/2000/svg',
					'a',
				)
				link.setAttribute('href', url + '#state-recipe')
				;[...state.children].forEach((child) => link.appendChild(child))
				state.appendChild(link)

				Alpine.bind(state, () => ({
					':class'() {
						let isCurrent = alpine.activeState === state.id
						return isCurrent ? 'text-orange-400' : ''
					},
				}))
			} else {
				state.classList.add('text-white')
			}
		})
	},
})
